import React from 'react';
import PropTypes from 'prop-types';
import DisclaimerButton from '../disclaimer/disclaimerButton';
import { chooseDisclaimer, DISCLAIMER_KEYS } from '../disclaimer/disclaimerMap';

const vehicleSummary = ({
  displaySummaryPicker,
  openModal,
  specificationSummary,
  summaryDisplay,
}) => {
  return (
    <div className="ch-col--12 sm:ch-col--6 lg:ch-col--5 print-container--vehicle-summary">
      <h3>Vehicle summary</h3>
      <table className="ch-clearfix ac-product__summary">
        <tbody>
          {Object.keys(specificationSummary).map((key) => {
            if (summaryDisplay.includes(key))
              return (
                <tr key={key}>
                  <th>{key}</th>
                  <td>
                    {specificationSummary[key]}
                    {DISCLAIMER_KEYS.includes(key) && (
                      <span className="ch-float--right">
                        <DisclaimerButton
                          disclaimer={chooseDisclaimer(
                            key,
                            specificationSummary,
                          )}
                        />
                      </span>
                    )}
                  </td>
                </tr>
              );
          })}
        </tbody>
      </table>
      {displaySummaryPicker && (
        <>
          <div className="ch-mt--2 summary-picker__prompt">
            <p className="ch-mb--0">
              <b>Something missing?</b>
            </p>
            <p className="ch-mb--0">Add more to your vehicle summary</p>
            <button
              className="ch-btn--link ch-pa--0"
              onClick={openModal}
              type="button"
            >
              Choose from our list of extra items
            </button>
          </div>
          <hr className="summary-picker__prompt ch-mv--4 sm:ch-hide" />
        </>
      )}
    </div>
  );
};

vehicleSummary.propTypes = {
  displaySummaryPicker: PropTypes.bool,
  openModal: PropTypes.func,
  specification: PropTypes.object,
  summaryDisplay: PropTypes.array,
};

export default vehicleSummary;
